// ContextLostOverlay (IMPLEMENTATION §2.1, §3 M11): the WebGL context was lost; the game was saved. The
// whole screen is the button ("Graphics were reset. Tap to reload."): a tap saves again and reloads.
export interface ContextLostOverlayProps {
  text: string;
  onTap(): void;
}

export function ContextLostOverlay({ text, onTap }: ContextLostOverlayProps) {
  return (
    <button type="button" class="ov-block ov-tap" data-overlay="contextLost" onClick={onTap}>
      <span class="ov-text">{text}</span>
    </button>
  );
}
